import { $ } from './utils/querySelector';

export function formValidation(selector = '.contact-form') {
    function onSubmitClick() {
        formElement.classList.add('validate');
    }

    const formElement = $()(selector);
    if (!formElement) return;

    $(formElement)(
        'button[type="submit"], input[type="submit"]'
    ).addEventListener('click', onSubmitClick);
}
